import type { GeneratorConfigV1 } from '../../types/generator-config';
import { GeneratorRenderer } from '../renderer/GeneratorRenderer';

interface EditorPreviewProps {
    config: GeneratorConfigV1;
    /**
     * Cible de l'aperçu. 'summary' saute directement à l'écran de résumé
     * pour montrer notamment le formulaire de captation de leads.
     */
    previewTarget?: 'form' | 'summary';
}

/**
 * Aperçu live de l'éditeur : utilise le GeneratorRenderer réel
 * pour que l'auteur voie exactement ce que verront ses clients. 
 */
export function EditorPreview({ config, previewTarget }: EditorPreviewProps) {
    return (
        <div className="editor-preview-wrap">
            <div className="preview-label">Aperçu en temps réel — testez votre générateur</div>
            <GeneratorRenderer config={config} previewTarget={previewTarget} />
        </div>
    );
}
